export const useChannel2Platform = () => {
  return (channel: Review.Detail['channel']) => {
    return {
      isShopee: channel === 1,
      isLazada: channel === 2,
      isMercado: channel === 3,
      isTikTok: channel === 4,
      isTikTokUS: channel === 5,
      isTikTokCommon: channel === 4 || channel === 5,
    };
  };
};
